module.exports = {"path":"/404.html","body":"<h1>NOT AVAILABLE OR DOES NOT EXISTS</h1>\n<p>Try refreshing the page…</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./404.md
// module id = 962
// module chunks = 0